import styles from "./EmptyState.module.scss";
import emptyImage from "@/assets/img/newEmpty.svg";

type Props = {
  img?: any;
  title?: string;
  text?: string;
  className?: string;
  backgroundColor?: string;
};

const EmptyState = ({ img, title, text, className = "", backgroundColor }: Props) => {
  return (
    <div
      className={`${styles.emptyState} ${className} gradientBorder`}
      style={{ background: backgroundColor }}
    >
      <img src={img || emptyImage} />
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
};

export default EmptyState;
